import { render } from "./image-display.vue?vue&type=template&id=2f3dd74e&ts=true"
import script from "./image-display.vue?vue&type=script&lang=ts"
export * from "./image-display.vue?vue&type=script&lang=ts"

import "./image-display.vue?vue&type=style&index=0&id=2f3dd74e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__